<template>

  <!-- Startup Cost Table -->
  <div class="switcher-inner-wrapper bg-white">
    <el-row :gutter="20">
      <el-col>

        <!-- Title & Period Switcher -->
        <div class="d-flex flex-column flex-md-row align-items-center align-items-md-start justify-content-between title-and-switcher-container">

          <!-- Title -->
          <h3 class="m-0 mb-3 mb-md-0 text-center text-md-left font-outfit-regular">
            {{ $t('charts.startupCostsSummary') }}
          </h3>
          <!-- /Title -->

          <!-- Period Switcher -->
          <div
            v-if="!tableAdjustment.journalPage"
            class="period-switcher"
          >
            <table-period-switcher @change="period = $event" />
          </div>
          <!-- /Period Switcher -->

        </div>
        <!-- /Title & Period Switcher -->

        <!-- Table -->
        <div id="monthly-table">
          <el-table
            ref="table"
            :data="tableData"
            row-key="id"
            :border="false"
            :stripe="false"
            size="small"
          >

            <!-- Fixed Column -->
            <el-table-column
              class-name="main-cells-1"
              label-class-name=""
              :fixed="!$breakpoint.xs"
              prop="name"
              :label="$t('tables.startupCosts.header')"
              :width="tableFirstColumnWidth"
            />
            <!-- /Fixed Column -->

            <!-- Period Columns -->
            <el-table-column
              v-for="column in columns"
              :key="column.id"
              class-name="main-cells"
              label-class-name="table-labels"
              align="right"
              :label="column.label"
              :min-width="tableAdjustment.columnWidth"
            >
              <template slot-scope="scope">
                <span class="currency">{{ scope.row.values[column.name] ? currencySymbol : '' }}</span>
                <span>{{ scope.row.values[column.name] ? getRoundedFormattedAmount(scope.row.values[column.name]) : '' }}</span>
              </template>
            </el-table-column>
            <!-- /Period Columns -->

          </el-table>
        </div>
        <!-- /Table -->

      </el-col>
    </el-row>
  </div>
  <!-- /Startup Cost Table -->

</template>

<script>
import MixinCurrencies from '@/mixins/currencies'
import MixinTable from '@/mixins/table'
import TablePeriodSwitcher from '@/components/Charts/Table/TablePeriodSwitcher'

export default {
  name: 'StartupCostsTable',

  components: {
    TablePeriodSwitcher
  },

  mixins: [
    MixinCurrencies,
    MixinTable
  ],

  props: {
    tableRowsToExpand: {
      type: Array,
      default: () => []
    },
    tableAdjustment: {
      type: Object,
      default: () => ({
        journalPage: false,
        period: 'monthly',
        tableFirstColumnWidth: 250,
        columnWidth: 118
      })
    },
    sharedIdea: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      period: this.tableAdjustment.period
    }
  },

  computed: {
    tableData () {
      let data = []

      if (
        this.$store.state.idea.storyMode.setUp.startupCosts.table &&
        this.$store.state.idea.storyMode.setUp.startupCosts.table[this.period]
      ) {
        data = this.$store.state.idea.storyMode.setUp.startupCosts.table[this.period]
      }

      // Expand Table Rows
      if (this.tableRowsToExpand.length > 0 && this.$refs.table !== undefined) {
        for (let i = 0; i < this.tableRowsToExpand.length; i++) {
          this.$refs.table.toggleRowExpansion({
            id: this.tableRowsToExpand[i]
          }, true)
        }
      }

      return data
    },

    columns () {
      let columns = []

      if (
        this.$store.state.idea.storyMode.setUp.startupCosts.table &&
        this.$store.state.idea.storyMode.setUp.startupCosts.table.columns[this.period]
      ) {
        columns = this.$store.state.idea.storyMode.setUp.startupCosts.table.columns[this.period]
      }

      return columns
    }
  }
}
</script>
<style scoped>
.period-switcher {
  max-width: 150px;
  min-width: 150px;
}

.title-and-switcher-container {
  padding: 0 30px;
}
</style>
